import Modal from "react-modal";
import React, { useEffect, useState } from "react";
import "./Factor.css";
import { useMediaQuery } from "react-responsive";
import AfterLoginNav from "../AfterLoginNav";

export default function EmptyTextModal({ modalIsOpen, Openchanger, text }) {
  const isSmall = useMediaQuery({ query: "(max-width: 768px)" });
  const [isEnamad, setIsEnamad] = useState(false);
  const customStylesDesktop = {
    overlay: {
      position: "fixed",
      zIndex: 1020,
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0, 0.5)",
      display: "flex",
      justifyContent: "center",
    },

    content: {
      background: "#ffffff",
      width: "400px",
      height: "150px",
      border: "0px",
      overflowY: "hidden",
      position: "relative",
      borderRadius: "0.8rem",
      inset: "9px",
    },
  };

  const customStylesMobile = {
    overlay: {
      position: "fixed",
      zIndex: 1020,
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0, 0.5)",
      display: "flex",
      justifyContent: "center",
    },

    content: {
      background: "#ffffff",
      width: "34rem",
      maxWidth: "calc(150vw - 2rem)",
      maxHeight: "calc(95vh - 1rem)",
      overflowY: "auto",
      border: "0px",
      position: "relative",
      borderRadius: "0.4rem",
      inset: "0px",
      margin: "0vh 0px 0px 0px",
    },
  };

  Modal.setAppElement("#root");

  function afterOpenModal() {}
  function closeModal() {
    Openchanger(false);
  }
  useEffect(() => {
    if (text) {
      if (typeof text.props.children !== "string") {
        setIsEnamad(true);
      } else {
        setIsEnamad(false);
      }
    }
  }, [text]);
  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        ariaHideApp={false}
        style={isSmall ? customStylesMobile : customStylesDesktop}
        contentLabel="Example Modal"
        backdrop="static"
        id={"factor-modal"}
      >
        <div className="header-modal-wrapper">
          <AfterLoginNav
            title={isEnamad ? "نماد اعتماد الکترونیک" : "نصب اپلیکیشن"}
            hasBack={closeModal}
          />
        </div>
        <div className={"container"} id={"factor-mbody"}>
          <div className="remove-cross" onClick={() => Openchanger(false)}>
            &#10006;
          </div>
          <div className="text-for-enamad">{text}</div>
        </div>
      </Modal>
    </>
  );
}
